import ReactStrapTable from "components/reactStrapTable";
import VerticalStatusPopover from "components/VerticalStatusPopover";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  ButtonGroup,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  InputGroup,
  Row,
} from "reactstrap";
import searchIcon from "../../../assets/icon/search.svg";
import columnSelectorIcon from "../../../assets/icon/column-selector.svg";
import claimsIcon from "../../../assets/icon/claims-purple.svg";
import dataEntryIcon from "../../../assets/icon/data-entry.svg";
// import iconStatus from "../../../assets/icon/pending.svg";
import resetAllIcon from "../../../assets/icon/resetall.svg";
import applyIcon from "../../../assets/icon/apply.svg";
import NotesShort from "components/NotesShort";
import threeDotsIcon from "assets/icon/3-dots.svg";
import plusIcon from "assets/icon/plus-icon-add-note.svg";
import uploadIcon from "assets/icon/upload-icon.svg";
import closeIcon from "assets/icon/close-icon.svg";
import DrugName from "components/DrugName";
import SearchButtons from "components/SearchButtons";
const rowData = [
  {
    id: 1,
    status: "Backordered",
    patient: "Smith, John",
    ndc: 34981319894,
    drugname: "Lisinopril 10 MG Tablet",
    quantity: 90,
    lastcontacted: "1/31/2024",
    notes: "Patient Willing to Wait, Declined",
  },
  {
    id: 2,
    status: "Backordered",
    patient: "Doe, Jane",
    ndc: 34981319895,
    drugname: "Metformin 500 MG Tablet",
    quantity: 180,
    lastcontacted: "5/6/2024",
    notes: "Urgent Patient need medicine",
  },
  {
    id: 3,
    status: "Backordered",
    patient: "Brown, Robert",
    ndc: 34981319896,
    drugname: "Synthroid 75 MG Tablet",
    quantity: 30,
    lastcontacted: "1/30/2024",
    notes: "No alternatives avialable",
  },
  {
    id: 4,
    status: "Backordered",
    patient: "Johnson, Mary",
    ndc: 34981319897,
    drugname: "Eliquis 5 MG Tablet",
    quantity: 60,
    lastcontacted: "2/1/2024",
    notes: "Critical Medication, Consider",
  },
  {
    id: 5,
    status: "Backordered",
    patient: "Wilson, James",
    ndc: 34981319898,
    drugname: "Jardiance 25 MG Tablet",
    quantity: 30,
    lastcontacted: "12/1/2024",
    notes: "Patient Switched to alternative",
  },
  {
    id: 6,
    status: "Backordered",
    patient: "Miller, Susan",
    ndc: 34981319842,
    drugname: "Ozempic 1mg/0.75ml Pen",
    quantity: 1,
    lastcontacted: "2/1/2024",
    notes: "No alternatives patient required",
  },
  {
    id: 6,
    status: "Backordered",
    patient: "Davis, Michael",
    ndc: 34981319811,
    drugname: "Freestyle Libre Sensors",
    quantity: 2,
    lastcontacted: "1/30/2024",
    notes: "Can substitute with Dexcom",
  },
  {
    id: 6,
    status: "Backordered",
    patient: "Garcia, Maria",
    ndc: 34981319844,
    drugname: "Lantus 100u/ml Vial",
    quantity: 2,
    lastcontacted: "2/1/2024",
    notes: "Patient considering semglee...",
  },
  {
    id: 6,
    status: "Backordered",
    patient: "Taylor, David",
    ndc: 34981319822,
    drugname: "Entresto 97/103 Tablet",
    quantity: 60,
    lastcontacted: "1/31/2024",
    notes: "Prior auth required for alternative",
  },
  {
    id: 6,
    status: "Backordered",
    patient: "Anderson, Lisa",
    ndc: 34981319823,
    drugname: "Trulicity 1.5mg/05ml Pen",
    quantity: 1,
    lastcontacted: "2/1/2024",
    notes: "Patient willing to switch to...",
  },
];
const BackOrdered = () => {
  const [columnOpen, setColumnOpen] = useState(false);
  const [tableData, setTableData] = useState(rowData);
  const [updateData, setUpdateData] = useState([]);
  const [data, setData] = useState([]);
  const [rSelected, setRSelected] = useState("off");

  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const [check, setCheck] = useState([
    {
      selectall: "",
      due: "",
      status: "",
      rx: "",
      patient: "",
      medication: "",
      filltype: "",
      entered: "",
    },
  ]);

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    if (name === "selectall") {
      setCheck({
        selectall: checked,
        due: checked,
        rx: checked,
        patient: checked,
        medication: checked,
        filltype: checked,
        entered: checked,
        status: checked,
      });
    } else {
      setCheck((prevCheck) => {
        const updatedCheck = { ...prevCheck, [name]: checked };
        const allSelected = Object.values(updatedCheck).every(
          (val) => val === true
        );
        updatedCheck.selectall = allSelected;
        return updatedCheck;
      });
    }
  };
  const renderButtons = (rowData) => {
    return <VerticalStatusPopover row={rowData} />;
  };

  const colHeader = [
    {
      dataField: "status",
      text: "Order Status",
      show: true,
      sort: true,
      width: 80,
      cellRenderer: (row, col) => renderButtons(row),
    },
    {
      dataField: "patient",
      text: "Patient Name",
      show: true,
      sort: true,
      width: 100,
    },
    {
      dataField: "ndc",
      text: "NDC",
      show: true,
      sort: true,
      width: 30,
    },
    {
      dataField: "drugname",
      text: "Drug Name",
      show: true,
      sort: true,
      width: 180,
      // cellRenderer: (rowData) => DrugName(rowData),
    },
    {
      dataField: "quantity",
      text: "Quantity",
      show: true,
      sort: true,
      width: 80,
    },
    {
      dataField: "lastcontacted",
      text: "Last Contacted",
      show: true,
      sort: true,
      width: 110,
      // cellRenderer: (rowData) => MedicationShort(rowData),
    },
    {
      dataField: "notes",
      text: "Notes",
      show: true,
      sort: true,
      width: 210,
      // cellRenderer: (rowData) => NotesShort(rowData),
    },
  ];

  const filterColumns = () => {
    const columnIndexes = Object.entries(check)
      .filter(([key, value]) => value === true)
      .map(([key]) => {
        if (key === "status") return 1;
        if (key === "due") return 2;
        if (key === "rx") return 3;
        if (key === "patient") return 4;
        if (key === "medication") return 5;
        if (key === "filltype") return 6;
        if (key === "entered") return 7;
        return -1;
      })
      .filter((index) => index !== -1);
    return colHeader.filter((_, index) => columnIndexes.includes(index));
  };
  const filteredColData = filterColumns();
  const totalCount = [
    check.due,
    check.status,
    check.rx,
    check.patient,
    check.medication,
    check.filltype,
    check.entered,
  ].filter(Boolean).length;
  const handleSubmit = () => {
    setUpdateData(filteredColData.length > 0 ? filteredColData : colHeader);
    setColumnOpen(false);
  };
  const toggleFilter = () => {
    setRSelected((prev) => (prev === "off" ? "on" : "off"));
  };

  const tableFilterData = tableData.length
    ? tableData.map((patient) => {
        return {
          id: patient.id,
          status: (
            <>
              <VerticalStatusPopover
                patientId={patient.id} // Example prop: Pass patient ID
                patientStatus={patient.status}
              />
            </>
          ),
          id: patient.id,
          status: patient.status,
          patient: patient.patient,
          ndc: patient.ndc,
          drugname: patient.drugname,
          quantity: patient.quantity,
          lastcontacted: patient.lastcontacted,
          notes: patient.notes,
        };
      })
    : [
        {
          id: "",
          status: "",
          patient: "",
          ndc: "",
          drugname: "",
          quantity: "",
          lastcontacted: "",
          notes: "",
        },
      ];

  return (
    <div className="table-card scroll-table position-relative border-0 rounded bg-white">
      <Row>
        <Col
          lg={7}
          className="d-flex justify-content-start "
          style={{ gap: "12px" }}
        >
          <SearchButtons
            InSize={200}
            placeHolder={"Search by Product Name"}
            data={tableData}
            row={rowData}
            setFilterData={setTableData}
          />
          <Dropdown
            isOpen={columnOpen}
            toggle={() => setColumnOpen(!columnOpen)}
          >
            <DropdownToggle className="clmn">
              <img src={columnSelectorIcon} alt="not available" />
              <span>
                Columns{" "}
                {totalCount > 0 && (
                  <div className="totalcount">{totalCount}</div>
                )}
              </span>
            </DropdownToggle>
            <DropdownMenu className="drop-down-clm">
              <DropdownItem className="dropdownitem-border drp-down-clm-item">
                <Input
                  type="checkbox"
                  name="selectall"
                  value={check.selectall}
                  onChange={handleCheck}
                  checked={check.selectall}
                />
                <span className="m-2">Select All</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border drp-down-clm-item">
                <Input
                  type="checkbox"
                  name="status"
                  value={check.status}
                  onChange={handleCheck}
                  checked={check.status}
                />
                <span className="m-2">status</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border drp-down-clm-item">
                <Input
                  type="checkbox"
                  name="due"
                  value={check.due}
                  onChange={handleCheck}
                  checked={check.due}
                />
                <span className="m-2">Due</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border drp-down-clm-item">
                <Input
                  type="checkbox"
                  name="patient"
                  value={check.patient}
                  onChange={handleCheck}
                  checked={check.patient}
                />
                <span className="m-2">Patient Name</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border drp-down-clm-item">
                <Input
                  type="checkbox"
                  name="rx"
                  value={check.rx}
                  onChange={handleCheck}
                  checked={check.rx}
                />
                <span className="m-2">Rx Number</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border drp-down-clm-item">
                <Input
                  type="checkbox"
                  name="filltype"
                  value={check.filltype}
                  onChange={handleCheck}
                  checked={check.filltype}
                />
                <span className="m-2">Fill Type</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border drp-down-clm-item">
                <Input
                  type="checkbox"
                  name="entered"
                  value={check.entered}
                  onChange={handleCheck}
                  checked={check.entered}
                />
                <span className="m-2">Entered</span>
              </DropdownItem>
              <div className="d-flex justify-content-center align-items-center p-2">
                <Button
                  onClick={() =>
                    setCheck({
                      selectall: false,
                      due: false,
                      medication: false,
                      rx: false,
                      patient: false,
                      filltype: false,
                      entered: false,
                      status: false,
                    })
                  }
                >
                  {" "}
                  <img src={resetAllIcon} alt="" /> Reset All
                </Button>
                <Button
                  color="primary"
                  onChange={handleCheck}
                  onClick={handleSubmit}
                >
                  {" "}
                  <img src={applyIcon} alt="" /> Apply
                </Button>
              </div>
            </DropdownMenu>
          </Dropdown>
          <div className="d-flex justify-content-center align-items-center gap-2">
            <span className="f-16 font-weight-600">Filter</span>
            <ButtonGroup className="filter-btn-group">
              <Button
                color="info"
                outline
                onClick={toggleFilter}
                active={rSelected === "off"}
              >
                OFF
              </Button>
              <Button
                color="info"
                outline
                active={rSelected === "on"}
                onClick={toggleFilter}
              >
                ON
              </Button>
            </ButtonGroup>
          </div>
        </Col>
        <Col className="d-flex justify-content-end">
          {" "}
          <Dropdown isOpen={dropdownOpen} toggle={toggle}>
            <DropdownToggle color="primary" className="togglebtn">
              {dropdownOpen ? (
                <img src={closeIcon} alt="icon" />
              ) : (
                <img src={threeDotsIcon} alt="icon" />
              )}
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem className="dropdownitem-border">
                <img src={plusIcon} /> Add Notes
              </DropdownItem>
              <DropdownItem className="dropdownitem-border">
                {" "}
                <img src={uploadIcon} /> Print
              </DropdownItem>
              <DropdownItem className="dropdownitem-border">
                {" "}
                <img src={uploadIcon} /> E-Rx Details{" "}
              </DropdownItem>
              <DropdownItem className="dropdownitem-border">
                {" "}
                <img src={uploadIcon} /> Forward Rx
              </DropdownItem>
              <DropdownItem className="dropdownitem-border">
                {" "}
                <img src={uploadIcon} /> Due
              </DropdownItem>
              <DropdownItem className="dropdownitem-border">
                {" "}
                <img src={uploadIcon} /> P/A
              </DropdownItem>
              <DropdownItem className="dropdownitem-border">
                {" "}
                <img src={uploadIcon} /> Rx History
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </Col>
      </Row>
      <div fixed-height={rowData.length > 0 ? "fixed-height" : "default"}>
        <ReactStrapTable
          id="final-review"
          data={tableFilterData}
          columns={updateData.length > 0 ? updateData : colHeader}
          enablerowRouting={false}
          redRow={[0]}
        />
      </div>
    </div>
  );
};

export default BackOrdered;
